<template>
  <div>
    <div v-if="conditionsDict && conditionsDict.length > 0">
      <div v-html="getValueFromCondition"></div>
    </div>
    <div v-if="!conditionsDict || conditionsDict.length == 0">
      <span>{{ formattedValue }}</span>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

/**
 * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LOS BOTONES
 * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
 * */
export default {
  name: 'cell-dt-string-type',
  data() {
    return {};
  },
  props: ['value', 'conditionsDict', 'index', 'readTransform'],
  computed: {
    formattedValue() {
      if (this.value && !Number.isNaN(this.value) && this.value !== '' && this.readTransform) {
        return eval(this.readTransform.replace('this', this.value));
      }
      return this.value;
    },
    getValueFromCondition() {
      let found = false;
      let index = 0;
      // Eval expression
      while (!found && index < this.conditionsDict.length) {
        found = this.$parent.fnEvalCondition(this.conditionsDict[index].ValueCondition, this.formattedValue, this.index);
        if (!found) {
          index++;
        }
      }
      // Get value if meet condition
      if (found) {
        const expression = this.conditionsDict[index].Value.replace('{{value}}', this.formattedValue);
        return expression;
      }
      return null;
    },
  },
  methods: {},
};
</script>
<style scoped></style>
